// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"db23be3c","57":"a6c51415","124":"cff9b150","153":"ff73a439","353":"a6ae83c4","449":"0ffb5098","453":"87e45203","660":"dff304d2","697":"31498dcd","712":"c4351c00","819":"1e839109"}[chunkId] + ".chunk.js";
};